import React from 'react';
import { motion } from 'framer-motion';
import { ShieldCheck } from 'lucide-react';
export function Guarantee() {
  return <section className="py-16 px-4 bg-brand-cream" data-id="element-62">
      <div className="max-w-3xl mx-auto text-center" data-id="element-63">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="bg-white p-8 md:p-12 rounded-3xl shadow-lg border border-gray-100" data-id="element-64">
          <div className="inline-flex justify-center items-center w-20 h-20 bg-brand-teal/10 text-brand-teal rounded-full mb-6" data-id="element-65">
            <ShieldCheck size={40} data-id="element-66" />
          </div>
          <h2 className="text-3xl font-bold text-brand-charcoal mb-6" data-id="element-67">
            🛡️ Garantía de 7 días sin preguntas
          </h2>
          <div className="space-y-4 text-lg text-gray-700" data-id="element-68">
            <p className="font-semibold" data-id="element-69">
              Descárgalo. Úsalo con tus pacientes esta semana.
            </p>
            <p data-id="element-70">
              Si no llegas a cada sesión con más claridad, más seguridad clínica
              y menos tiempo preparando material fuera de hora, te devolvemos el
              100% del dinero.
            </p>
            <p className="font-bold text-brand-teal" data-id="element-71">
              Sin preguntas. Sin formularios. Sin vueltas.
            </p>
          </div>
        </motion.div>
      </div>
    </section>;
}